import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Location = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    className={props.className}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M12.0006667,3.99999995 C15.6512368,3.99999995 18,6.72510264 18,10.1666667 C18,11.2364492 17.3876265,12.683841 16.3012775,14.4812095 C15.9758501,15.0196302 15.6122764,15.5804589 15.2171546,16.1577794 C14.625738,17.0219102 13.9931757,17.8809185 13.3606707,18.6963589 L13.0410078,19.1046214 L12.5133857,19.7594362 L12.4878199,19.7885483 L12.4559415,19.8204307 L12.4268325,19.8460001 L12.3928092,19.8726674 L12.3248686,19.9160654 L12.2529996,19.9505434 L12.2128548,19.9655198 L12.1780818,19.9760202 L12.1358933,19.9862758 L12.0575803,19.997625 L12.0226196,19.9996484 L11.9787956,19.9996484 L11.9438347,19.997632 L11.9004191,19.992427 L11.8655203,19.9862924 L11.8233305,19.976042 L11.7885562,19.9655459 L11.7484096,19.9505744 L11.6765363,19.9161053 L11.6085904,19.8727156 L11.5745638,19.8460524 L11.5454517,19.8204866 L11.5135694,19.7886082 L11.488,19.7594992 L11.2525622,19.4707886 L10.9602465,19.104685 C10.8580208,18.9754208 10.751224,18.8391302 10.6405038,18.6964227 C10.0078408,17.8809825 9.37512046,17.0219743 8.78355592,16.1578435 C8.38833518,15.5805228 8.02467037,15.0196938 7.69916138,14.4812726 C6.61253111,12.6838882 5.99999996,11.2364858 5.99999996,10.1666667 C5.99999996,6.72488654 8.34901735,3.99999995 12.0006667,3.99999995 Z M12.0006667,5.33333329 C9.13298261,5.33333329 7.3333333,7.42094673 7.3333333,10.1666667 C7.3333333,10.9150294 7.87496595,12.1948997 8.84018242,13.7914547 C9.15186803,14.3070108 9.50204151,14.847034 9.88377738,15.4046566 C10.3439758,16.0768936 10.8311744,16.7478258 11.3238025,17.3968037 L11.8530408,18.0831784 L12.0006667,18.2706667 L12.307121,17.879162 C12.9244598,17.0832743 13.5417412,16.245017 14.1168454,15.4047207 C14.498486,14.8470979 14.8485721,14.3070744 15.1601801,13.7915178 C16.1251649,12.1949469 16.6666667,10.9150659 16.6666667,10.1666667 C16.6666667,7.42111737 14.8672077,5.33333329 12.0006667,5.33333329 Z M12,7.3333333 C13.4727593,7.3333333 14.6666667,8.52724065 14.6666667,9.99999999 C14.6666667,11.4727593 13.4727593,12.6666667 12,12.6666667 C10.5272407,12.6666667 9.33333332,11.4727593 9.33333332,9.99999999 C9.33333332,8.52724065 10.5272407,7.3333333 12,7.3333333 Z M12,8.66666665 C11.2636203,8.66666665 10.6666667,9.26362032 10.6666667,9.99999999 C10.6666667,10.7363797 11.2636203,11.3333333 12,11.3333333 C12.7363797,11.3333333 13.3333333,10.7363797 13.3333333,9.99999999 C13.3333333,9.26362032 12.7363797,8.66666665 12,8.66666665 Z"
        id="path-1-location"
      ></path>
    </defs>
    <g
      id="icon-24x24px[16x16px]---line&amp;solid"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Atom/icon/maps/location/line">
        <mask id="mask-2-location" fill={props.color || theme.palette.grey600}>
          <use xlinkHref="#path-1-location"></use>
        </mask>
        <use
          id="Combined-Shape"
          fill={props.color || theme.palette.grey600}
          fillRule="nonzero"
          xlinkHref="#path-1-location"
        ></use>
        <g
          id="Group"
          mask="url(#mask-2-location)"
          fill={props.color || theme.palette.grey600}
        >
          <g id="🎨-color">
            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
